import { createSlice } from "infrastructure/store/lib";
import { sliceMixin } from "infrastructure/store/reducers";
import { MenuItem } from "consts/shipmentTracking";
import type { ShipmentTrackingState } from "./types";
import initialState, { sliceToken } from "./state";
import { getTransactionTrackingDeliveryCodesThunk } from "./thunks";
import {
    shipmentTrackingResourceRequestLoading,
    shipmentTrackingResourceRequestRejected,
    exportShipmentTrackingResourceLoading,
    transactionTrackingDeliveryCodesRequestFulfilled
} from "./reducers";

const slice = createSlice({
    name: sliceToken,
    initialState,
    reducers: {
        ...sliceMixin<ShipmentTrackingState>(initialState),
        changeExportTransactionTrackingDeliveryCodesLoading:
            exportShipmentTrackingResourceLoading(MenuItem.TransactionTrackingDeliveryCodes)
    },
    extraReducers: builder => {
        builder
            .addCase(
                getTransactionTrackingDeliveryCodesThunk.pending,
                shipmentTrackingResourceRequestLoading(MenuItem.TransactionTrackingDeliveryCodes)
            )
            .addCase(
                getTransactionTrackingDeliveryCodesThunk.fulfilled,
                transactionTrackingDeliveryCodesRequestFulfilled
            )
            .addCase(
                getTransactionTrackingDeliveryCodesThunk.rejected,
                shipmentTrackingResourceRequestRejected(MenuItem.TransactionTrackingDeliveryCodes)
            );
    }
});

export const {
    name,
    actions: {
        changeExportTransactionTrackingDeliveryCodesLoading
    }
} = slice;

export default slice.reducer;
